import React from 'react'
import Modal from 'react-modal'
import {connect} from 'react-redux'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import { clientProfileFormGetRelations } from 'state/actions'
import styles from './listSelect.scss'
import Input from './input'
import { DatePicker } from 'components/shared/datePicker'
import { SearchableSelectWrapper } from '../components/shared/select/SelectWrap'
import moment from 'moment'
import {dateFormatter} from 'lib/helpers'

import underscore from 'underscore'
import i18n from 'lib/i18n'
import uuidv4 from 'uuid/v4'
const _ = i18n('clients')

import uuidv1 from 'uuid/v1'

const genderHashMap = {
    "M": "1",
    "F": "2",
    "V": "2"
}

const defaultRelationData = {
    clientNumber: "",
    clientFirstName: "",
    clientLastName: "",
    clientGender: "",
    clientBirthDate: "",
    clientRelationType: "",
}

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
        zIndex: 2
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        minHeight: '550px',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '1em',
    },
}

export default class RelationListSelect extends React.Component {
    static propTypes = {
        data: React.PropTypes.array,
        genderOptions: React.PropTypes.array,
        relationOptions: React.PropTypes.array
    }

    constructor(props) {
        super(props)

        this.state = {
            modalIsOpen: false,
            relationData: {
                clientNumber: "",
                clientFirstName: "",
                clientLastName: "",
                clientGender: "",
                clientBirthDate: "",
                clientRelationType: "",
            },
            relationKey: "",
            formType: "create",
            relationErrors: defaultRelationData,
            disabledInputs: false
        }
    }

    getIcon() {
        try {
            return require(`resources/images/a-trash_1x_ovbBlue.svg`)
        } catch(err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    openModal() {
        this.setState({modalIsOpen: !this.state.modalIsOpen})
    }

    changeClientNumberValue = (ev) => {
        const { dispatch } = this.props
        let { relationData } = this.state

        relationData['clientNumber'] = ev.target.value

        this.setState({relationData: relationData})
    }

    changeLastNameValue = (ev) => {
        let { relationData } = this.state

        relationData['clientLastName'] = ev.target.value

        this.setState({relationData: relationData})
    }

    changeFirstNameValue = (ev) => {
        let { relationData } = this.state

        relationData['clientFirstName'] = ev.target.value

        this.setState({relationData: relationData})
    }

    changeRelationTypeValue = (ev) => {
        let { relationData } = this.state

        relationData['clientRelationType'] = ev.value

        this.setState({relationData: relationData})
    }

    changeGenderValue = (ev) => {
        let { relationData } = this.state

        relationData['clientGender'] = ev.value

        this.setState({relationData: relationData})
    }

    changeBirthDateValue = (ev) => {
        let { relationData } = this.state

        relationData['clientBirthDate'] = ev

        this.setState({relationData: relationData})
    }

    checkFormMethod = (relationKey, formType) => {
        let { data } = this.props

        // Get the requested data based on form type
        if(formType == 'update')
        {
            data = data[relationKey]

            this.setState({relationData: {
                clientNumber: data.contactNumber.value,
                clientFirstName: data.contactFirstName.value,
                clientLastName: data.contactLastName.value,
                clientGender: data.contactgender.value,
                clientBirthDate: data.contactdateOfBirth.value,
                clientRelationType: data.contactType.value
            }});
        }
    }

    validateForm = () => {
        let { data, dispatch } = this.props
        const { relationKey, formType } = this.state

        let formStatus = true

        let { relationErrors } = this.state
        const { clientNumber, clientFirstName, clientLastName, clientGender, clientBirthDate, clientRelationType } = this.state.relationData

        relationErrors = {...defaultRelationData}

        if(clientLastName == "")
        {
            relationErrors["clientLastName"] = _('requiredField')

            formStatus = false
        }
        else if(clientLastName.length > 50)
        {
            relationErrors["clientLastName"] =  _('maxLength50')

            formStatus = false
        }

        if(clientFirstName.length > 50)
        {
            relationErrors["clientFirstName"] =  _('maxLength50')

            formStatus = false
        }

        if(clientRelationType == "")
        {
            relationErrors["clientRelationType"] = _('requiredField')

            formStatus = false
        }

        this.setState({relationErrors: {...relationErrors}, formStatus: formStatus})

        if(formStatus == true)
        {
            this.saveRelationData()
        }
    }

    saveRelationData = () => {
        let { data, dispatch } = this.props
        const { relationKey, formType } = this.state

        let { relationErrors } = this.state
        const { clientNumber, clientFirstName, clientLastName, clientGender, clientBirthDate, clientRelationType } = this.state.relationData

        if(formType == 'update')
        {
            data = data[relationKey]

            dispatch({
                type: "redux-form/CHANGE",
                field: data.contactNumber.name,
                value: clientNumber,
                touch: true,
                form: "clientProfileEdit"
            })

            dispatch({
                type: "redux-form/CHANGE",
                field: data.contactFirstName.name,
                value: clientFirstName,
                touch: true,
                form: "clientProfileEdit"
            })

            dispatch({
                type: "redux-form/CHANGE",
                field: data.contactLastName.name,
                value: clientLastName,
                touch: true,
                form: "clientProfileEdit"
            })

            dispatch({
                type: "redux-form/CHANGE",
                field: data.contactType.name,
                value: clientRelationType,
                touch: true,
                form: "clientProfileEdit"
            })

            dispatch({
                type: "redux-form/CHANGE",
                field: data.contactgender.name,
                value: clientGender,
                touch: true,
                form: "clientProfileEdit"
            })

            dispatch({
                type: "redux-form/CHANGE",
                field: data.contactdateOfBirth.name,
                value: clientBirthDate,
                touch: true,
                form: "clientProfileEdit"
            })
        }
        else
        {
            data.addField({
                contactNumber: clientNumber,
                contactName: clientFirstName + " " + clientLastName,
                contactFirstName: clientFirstName,
                contactLastName: clientLastName,
                contactType: clientRelationType,
                contactdateOfBirth: clientBirthDate,
                contactgender: clientGender,
                uniqueId: uuidv4()
            })
        }

        this.setState({
            relationData: {...defaultRelationData},
            formType: "create",
            relationErrors: {...defaultRelationData},
            relationKey: ""
        })
        this.openModal()
    }

    autocompleteRelationData = () => {
        const { officeClients, dispatch } = this.props
        const { clientNumber, clientFirstName, clientLastName, clientGender, clientBirthDate, clientRelationType } = this.state.relationData

        if(clientNumber.length > 3)
        {
            this.setState({disabledInputs: true})
            dispatch(clientProfileFormGetRelations({clientNumber: clientNumber})).then((response) => {
                Object.keys(response).map((relationIndex) => {
                    if (response[relationIndex].clientNumber == clientNumber)
                    {
                        let gender = null;

                        gender = underscore.has(genderHashMap,response[relationIndex].gender) ? genderHashMap[response[relationIndex].gender] : ""

                        this.setState({relationData: {
                            clientNumber: response[relationIndex].clientNumber,
                            clientFirstName: response[relationIndex].firstName,
                            clientLastName: response[relationIndex].lastName,
                            clientRelationType: "",
                            clientBirthDate: response[relationIndex].dateOfBirth,
                            clientGender: gender
                        }});
                    }
                })

                this.setState({disabledInputs: false})
            })
        }
    }

    removeItemFromList( itemUniqueId ) {
        const data = this.props.data

        Object.keys(data).map((dataKey) => {
            if( data[dataKey] && data[dataKey] !== undefined && data[dataKey].uniqueId.value === itemUniqueId ) {
                data.removeField(dataKey)
            }
        })
    }

    modalContentPopup()
    {
        // Get the requested data from props and state
        let { data } = this.props
        const { relationKey, formType, relationErrors, disabledInputs } = this.state
        const { clientNumber, clientFirstName, clientLastName, clientGender, clientBirthDate, clientRelationType } = this.state.relationData

        let errorData = false;

        return (
            <div className={styles.clientModalContent}>
                <span className={styles.title}>{_("addRelation")}</span>

                <label>{_('clientNumber')}</label>
                <input
                    type="text"
                    onChange={(ev) => this.changeClientNumberValue(ev)}
                    onBlur={(ev) => this.autocompleteRelationData(ev)}
                    value={clientNumber}
                    disabled={disabledInputs}
                />
                < div className={ styles.error }> {relationErrors && relationErrors["clientNumber"] != "" && relationErrors['clientNumber'] } </div>

                <label>{_('lastName')} *</label>
                <input
                    type="text"
                    onChange={(ev) => this.changeLastNameValue(ev)}
                    value={clientLastName}
                    disabled={disabledInputs}
                />
                < div className={ styles.error }> {relationErrors && relationErrors["clientLastName"] != "" &&  relationErrors['clientLastName'] } </div>

                <label>{_('firstName')} </label>
                <input
                    type="text"
                    onChange={(ev) => this.changeFirstNameValue(ev)}
                    value={clientFirstName}
                    disabled={disabledInputs}
                />
                < div className={ styles.error }> {relationErrors && relationErrors["clientFirstName"] != "" &&  relationErrors['clientFirstName'] } </div>

                <label>{_('type')} *</label>
                <SearchableSelectWrapper
                    options={this.props.relationOptions}
                    isSearchable
                    value={clientRelationType}
                    onChange={(ev) => this.changeRelationTypeValue(ev)}
                    isDisabled={disabledInputs}
                />
                < div className={ styles.error }> {relationErrors && relationErrors["clientRelationType"] != "" &&  relationErrors['clientRelationType'] } </div>

                <label>{_('gender')} </label>
                <SearchableSelectWrapper
                    options={this.props.genderOptions}
                    isSearchable
                    value={clientGender}
                    onChange={(ev) => this.changeGenderValue(ev)}
                    isDisabled={disabledInputs}
                />

                <div className={styles.datepickerLabelField}>
                    <label>{_('dateOfBirth')} </label>
                    <DatePicker
                        value={clientBirthDate}
                        onChange={(ev) => this.changeBirthDateValue(ev)}
                        disabled={disabledInputs}
                    />
                </div>

                <div className={styles.clientModalButtons}>
                    <input
                        onClick={() => {
                            this.setState({
                                relationData: {...defaultRelationData},
                                formType: "create",
                                relationErrors: {...defaultRelationData},
                                relationKey: ""
                            })
                            this.openModal()
                        }}
                        type="button"
                        className={styles.cancel}
                        value={_("cancel")}
                    />
                    <input
                        onClick={() => {
                            this.validateForm()
                        }}
                        type="button"
                        className={styles.next + " " + (!errorData && styles.enabled) }
                        value={_("clientAdd")}
                        disabled={errorData}
                    />

                </div>
            </div>
        )
    }

    printSelect(item, options) {
        let itemValue = ""

        if (item.value == undefined) {
            return ""
        }

        options.map((key, i) => {
            if (Number(item.value) == Number(key.value)) {
                itemValue = key.label
            }
        })

        return itemValue
    }
    render() {
        const {data, genderOptions, relationOptions} = this.props
        const {modalIsOpen} = this.state

        return (
            <div className={styles.moduleSection}>
                <div className={styles.clientsTableContainer}>
                    {!underscore.isEmpty(data) && underscore.isArray(data) && (data[0] !== 'Too many rows') &&
                    <Table
                        className={styles.table}
                        itemsPerPage={50}
                        topPagination=""
                        filterable={[]}
                        sortable={[
                            "contactType.value",
                            "contactLastName.value",
                            "contactFirstName.value",
                            "contactdateOfBirth.value",
                            "contactgender.value",
                            "contactNumber.value"
                        ]}
                        defaultSort={{
                            column: 'contactName.value',
                            direction: 'asc',
                        }}
                    >
                        <Thead>
                        <Th column="contactType.value">
                            <strong>{_('type')}</strong>
                        </Th>
                        <Th column="contactLastName.value">
                            <strong>{_('lastName')}</strong>
                        </Th>
                        <Th column="contactFirstName.value">
                            <strong>{_('firstName')}</strong>
                        </Th>
                        <Th column="contactgender.value">
                            <strong>{_('gender')}</strong>
                        </Th>
                        <Th column="contactdateOfBirth.value">
                            <strong>{_('birthday')}</strong>
                        </Th>
                        <Th column="contactNumber.value">
                            <strong>{_('clientNumber')}</strong>
                        </Th>
                        <Th column="">
                            <strong></strong>
                        </Th>
                        <Th column="checkEmail">
                            <strong></strong>
                        </Th>
                        </Thead>
                        { data.map((item, key) =>
                            <Tr className="centered" key={item.uniqueId.value} id={item.uniqueId.value}>
                                <Td column="contactType.value">
                                    {this.printSelect(item.contactType, relationOptions)}
                                </Td>
                                <Td column="contactLastName.value">{item.contactLastName.value}</Td>
                                <Td column="contactFirstName.value">{item.contactFirstName.value}</Td>
                                <Td column="contactgender.value">
                                    {this.printSelect(item.contactgender, genderOptions)}
                                </Td>
                                <Td column="contactdateOfBirth.value">{dateFormatter(item.contactdateOfBirth.value)}</Td>
                                <Td column="contactNumber.value">{item.contactNumber.value}</Td>
                                <Td column="">
                                    <button type="button"
                                            className={styles.editFieldButton}
                                            onClick={() => {
                                                this.setState({relationKey: key, formType: "update"})
                                                this.checkFormMethod(key, "update")
                                                this.openModal()
                                            }}><img src={require('resources/images/a-edit_1x_blue.svg')}/>
                                    </button>
                                </Td>
                                <Td column="checkEmail">
                                    <button type="button" className={styles.removeFieldsButton} onClick={event => {
                                        event.preventDefault()
                                        this.removeItemFromList(item.uniqueId.value)
                                    }}>
                                        <img src={this.getIcon()}/>
                                    </button>
                                </Td>
                            </Tr>
                        )
                        }
                    </Table>
                    }

                    <button type="button"
                            className={styles.addFieldButton}
                            onClick={() => {
                                this.openModal()
                            }}>+
                    </button>
                </div>
                <Modal
                    isOpen={modalIsOpen}
                    style={customStyles}
                    contentLabel="Modal"
                >
                    {this.modalContentPopup()}
                </Modal>
            </div>


        )
    }
}



// WEBPACK FOOTER //
// ./components/relationListSelect.jsx